import React from 'react';
import { Link } from 'react-router-dom';
import { Sun, Battery, Zap, Thermometer, Wind, Car, ArrowRight } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { services } from '../../data/mock';

const iconMap = {
  Sun: Sun,
  Battery: Battery,
  Zap: Zap,
  Thermometer: Thermometer,
  Wind: Wind,
  Car: Car
};

const ServicesSection = () => {
  return (
    <section className="py-12 md:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="inline-block text-[#B5D43B] font-semibold text-sm tracking-wider uppercase mb-4">
            Our Services
          </span>
          <h2 className="heading-2 mb-5">
            Complete Home Energy Solutions
          </h2>
          <p className="body-large">
            We're not just a solar company. We provide comprehensive energy solutions 
            to help you reduce bills and future-proof your home.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id} 
                className="group border border-black/5 hover:border-[#B5D43B]/30 card-hover bg-white"
              >
                <CardContent className="p-6">
                  {/* Icon */}
                  <div className="w-14 h-14 rounded-2xl bg-[#B5D43B]/15 flex items-center justify-center mb-5 group-hover:bg-[#B5D43B]/25 transition-colors">
                    <IconComponent className="w-7 h-7 text-[#3D5A47]" />
                  </div>
                  
                  {/* Content */}
                  <h3 className="font-semibold text-lg text-[#3D5A47] mb-3">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-5">
                    {service.shortDescription}
                  </p>
                  
                  {/* Link */}
                  <Link 
                    to={`/services#${service.id}`}
                    className="inline-flex items-center gap-2 text-[#3D5A47] font-medium text-sm group-hover:gap-3 transition-all"
                  >
                    Learn more
                    <ArrowRight className="w-4 h-4" />
                  </Link>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link 
            to="/services"
            className="inline-flex items-center gap-2 text-[#3D5A47] font-medium hover:text-[#B5D43B] transition-colors"
          >
            View all services
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
